import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { Tooltip } from "@excalidraw/excalidraw/components/Tooltip";
import { shield } from "@excalidraw/excalidraw/components/icons";

export const EncryptedIcon = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      return;
    }
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        setIsOpen(false);
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isOpen]);

  return (
    <>
      <button
        type="button"
        className="encrypted-icon tooltip"
        aria-label="Local & Private Storage"
        onClick={() => setIsOpen(true)}
        style={{
          background: "none",
          border: "none",
          padding: 0,
          cursor: "pointer",
          display: "inline-flex",
          alignItems: "center",
        }}
      >
        <Tooltip
          label="100% Local & Private — Stored on your device only"
          long={true}
        >
          {shield}
        </Tooltip>
      </button>

      {isOpen &&
        createPortal(
          <div
            className="Modal"
            role="dialog"
            aria-modal="true"
            style={{
              position: "fixed",
              inset: 0,
              zIndex: 999999,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              className="Modal__background"
              onClick={() => setIsOpen(false)}
              style={{
                position: "fixed",
                inset: 0,
                backgroundColor: "rgba(0, 0, 0, 0.4)",
                backdropFilter: "blur(2px)",
              }}
            />
            <div
              className="Island"
              style={{
                position: "relative",
                zIndex: 1,
                width: "min(480px, 90vw)",
                backgroundColor: "var(--island-bg, #1e1e2e)",
                color: "var(--text-primary-color, #cdd6f4)",
                borderRadius: "12px",
                boxShadow: "0 20px 40px rgba(0,0,0,0.3)",
                padding: "1.75rem",
                border:
                  "1px solid var(--dialog-border-color, rgba(255,255,255,0.1))",
                boxSizing: "border-box",
                fontFamily: "var(--ui-font)",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: "1.25rem",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "0.6rem",
                    fontSize: "1.2rem",
                    fontWeight: 600,
                  }}
                >
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      color: "var(--color-primary, #6965db)",
                    }}
                  >
                    {shield}
                  </span>
                  <span>Local &amp; Private Storage</span>
                </div>
                <button
                  type="button"
                  onClick={() => setIsOpen(false)}
                  style={{
                    background: "none",
                    border: "none",
                    fontSize: "1.25rem",
                    cursor: "pointer",
                    color: "inherit",
                    opacity: 0.7,
                    padding: "0.2rem 0.5rem",
                    lineHeight: 1,
                  }}
                  aria-label="Close"
                >
                  ✕
                </button>
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "1rem",
                  fontSize: "0.95rem",
                  lineHeight: 1.6,
                  color: "var(--text-secondary-color, #bac2de)",
                }}
              >
                <p style={{ margin: 0 }}>
                  <strong
                    style={{ color: "var(--text-primary-color, #cdd6f4)" }}
                  >
                    🔒 No Server Storage:
                  </strong>{" "}
                  Your drawings, elements, and whiteboard data are never
                  uploaded, synced, or saved to any remote cloud server.
                </p>
                <p style={{ margin: 0 }}>
                  <strong
                    style={{ color: "var(--text-primary-color, #cdd6f4)" }}
                  >
                    💾 100% On Your Device:
                  </strong>{" "}
                  All canvas content is stored locally in your browser and
                  exported directly to your disk as <strong>.iwd</strong> files.
                </p>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: "1.5rem",
                }}
              >
                <button
                  type="button"
                  onClick={() => setIsOpen(false)}
                  style={{
                    backgroundColor: "var(--color-primary, #6965db)",
                    color: "#fff",
                    border: "none",
                    borderRadius: "8px",
                    padding: "0.6rem 1.4rem",
                    fontSize: "0.95rem",
                    fontWeight: 600,
                    cursor: "pointer",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                  }}
                >
                  Got it
                </button>
              </div>
            </div>
          </div>,
          document.body,
        )}
    </>
  );
};
